import { Pipe, PipeTransform } from "@angular/core";
import { ItemPreguntaDTO, PreguntaDTO } from "@DTOS";
import { Nilable } from "@shared/utils";

@Pipe({
    name: "condicionTexto"
})
export class CondicionTextoPipe implements PipeTransform {

    transform(condicion: string, preguntas: PreguntaDTO[]): string {
        let condicionParseada = condicion;
        if (condicionParseada != null) {
            condicionParseada = condicionParseada.replace(/\|/g, " [O] " ).replace(/&/g, " [Y] ").replace(/~/g, " [NO] ");
            const patronItem = /(i[0-9]+)/g;
            const idsItems = condicionParseada.match(patronItem);
            let item = "";
            if (idsItems != null) {
                idsItems.map(itemId => parseInt(itemId.replace("i", ""), 10)).forEach(idItem => {
                    preguntas.forEach(preguntaDTO => {
                        let subpregunta: Nilable<PreguntaDTO> = null;
                        let itemPreguntaDTO: ItemPreguntaDTO;
                        if (preguntaDTO.esMatriz()) {
                            subpregunta = preguntaDTO.preguntas?.find(subpreguntaDTO =>
                                subpreguntaDTO.items.some(itemSubpregunta => itemSubpregunta.id === idItem)) ?? null;
                            itemPreguntaDTO = subpregunta?.items.find(itemSubpregunta =>
                                itemSubpregunta.id === idItem)!;
                        } else {
                            itemPreguntaDTO = preguntaDTO?.items.find(itemDTO =>
                                itemDTO.id === idItem)!;
                        }
                        if (itemPreguntaDTO != null) {
                            item = `"${itemPreguntaDTO.texto}"${(subpregunta == null ? "" : ` en ${subpregunta.texto}`)} en ${preguntaDTO.idRelativo}`;
                            if (preguntaDTO.idBloque) {
                                item = item + " (Bloque " + preguntaDTO.idBloque + ")";
                            }
                        }
                    });
                    condicionParseada = condicionParseada.replace(`i${idItem}`, item);
                });
            }
        }
        return condicionParseada;
    }

}
